import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { Checkbox } from 'ui-components/components/checkbox';
import { noop } from 'ui-components/default-props/noop';
import { testId } from 'ui-components/services/testid-service';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import ConnectedVoidTypeFilterPill from '../../../../../components/actionable-filter-pill/connected/shipping/void-type';
import { getVoidTypeFilterCriteria } from '../../../../../components/void-type/void-type-mappings';
import { isNullIndicator } from '../../../../../services/filtering/collection-filter-mapping-service';
import RemoveAllFiltersDropdownMenuItem from '../../../../../components/remove-all-filters-dropdown-menu-item';
import messages from './messages';
import { VOID_TYPE } from '../../../../../filters/constants';
import style from '../../../../../services/filtering/filter-form-render-service/common.module.less';

// Custom checked function for void type filter
// Need to handle both raw (before transformation) and transformed filter formats
const isVoidTypeOptionChecked = (existingFilters, argumentOption) => {
  if (existingFilters.length === 0) {
    return false;
  }

  return existingFilters.some((filterObject) => {
    const { criterionArgumentValue, criterionOperatorValue } = filterObject;

    // Check for Manual void type:
    // - Raw format (before transformation): criterionArgumentValue === 'empty'
    // - Transformed format (after transformation): criterionOperatorValue === 'empty'
    if (argumentOption.value === isNullIndicator) {
      return criterionArgumentValue === isNullIndicator || criterionOperatorValue === isNullIndicator;
    }

    // Check for Refund Assist: option.value is [3,4,6], filter has criterionArgumentValue=[3,4,6]
    if (Array.isArray(argumentOption.value) && Array.isArray(criterionArgumentValue)) {
      return (
        argumentOption.value.length === criterionArgumentValue.length &&
        argumentOption.value.every((val) => criterionArgumentValue.includes(val))
      );
    }

    return false;
  });
};

export default {
  id: VOID_TYPE,
  displayName: <FormattedMessage {...messages.voidTypeFilterLabel} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'voidType',
  render: (criteriaInformations, existingFiltersHelpers) => {
    const voidTypeCriteria = getVoidTypeFilterCriteria();
    const { existingFilters, onApplyFilter, onRemoveFilter, removeAllOfTheseFilters } = existingFiltersHelpers;
    const hasExistingFilters = !!existingFilters.length;

    const onArgumentOptionToggled = (criterionArgument) => {
      // Check if this option is currently selected
      const isCurrentlySelected = isVoidTypeOptionChecked(existingFilters, criterionArgument);

      if (!isCurrentlySelected) {
        // Adding filter
        onApplyFilter(criteriaInformations.selectedFilterBy, undefined, criterionArgument);
        return;
      }

      // Removing filter - need to find the matching filter (handle both raw and transformed formats)
      const existingFilter = existingFilters.find((filter) => {
        if (criterionArgument.value === isNullIndicator) {
          return filter.criterionArgumentValue === isNullIndicator || filter.criterionOperatorValue === isNullIndicator;
        }
        if (Array.isArray(criterionArgument.value) && Array.isArray(filter.criterionArgumentValue)) {
          return (
            criterionArgument.value.length === filter.criterionArgumentValue.length &&
            criterionArgument.value.every((val) => filter.criterionArgumentValue.includes(val))
          );
        }
        return false;
      });

      if (existingFilter) {
        onRemoveFilter(existingFilter);
      }
    };

    return (
      <div {...testId('filter-dropdown-menu-contents')}>
        <RemoveAllFiltersDropdownMenuItem hasExistingFilters={hasExistingFilters} onRemoveAllFiltersButtonClick={removeAllOfTheseFilters} />
        {voidTypeCriteria.map((option, index) => (
          <DropdownMenuItem key={index} className={style['checklist-row']} onClick={() => onArgumentOptionToggled(option)}>
            <Checkbox checked={isVoidTypeOptionChecked(existingFilters, option)} label={option.displayName} onChange={noop} />
          </DropdownMenuItem>
        ))}
      </div>
    );
  },
  shouldHideActionButtons: true,
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  actionableFilterPill: ConnectedVoidTypeFilterPill,
};
